import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

/**
 * Fetch status data for all employees in a venue
 * @param {string} venueId - The venue ID
 * @param {string[]} employeeIds - Array of employee IDs to get status for (optional)
 * @returns {Promise<Object>} Promise that resolves to employee status data
 */
export const getEmployeesStatus = async (venueId, employeeIds = []) => {
    try {
        const getEmployeesStatusFunction = httpsCallable(functions, 'getEmployeesStatus');
        const result = await getEmployeesStatusFunction({
            venueId,
            employeeIds
        });

        return result.data;
    } catch (error) {
        console.error(`Error fetching employees status for venue ${venueId} (employee count: ${employeeIds.length}):`, error);
        throw error;
    }
};

/**
 * Convert backend timestamp to Date object
 * @param {Object} timestamp - Firebase timestamp object
 * @returns {Date} JavaScript Date object
 */
export const convertTimestampToDate = (timestamp) => {
    if (!timestamp) return null;
    if (timestamp.toDate) return timestamp.toDate();
    if (timestamp.seconds) return new Date(timestamp.seconds * 1000);
    return new Date(timestamp);
};

/**
 * Process employee status data from backend
 * @param {Object} statusData - Raw status data from backend
 * @returns {Object} Processed status data with Date objects
 */
export const processEmployeeStatusData = (statusData) => {
    if (!statusData || !statusData.employees) return { employees: [] };

    return {
        ...statusData,
        employees: statusData.employees.map(employee => ({
            ...employee,
            shiftInfo: employee.shiftInfo ? {
                ...employee.shiftInfo,
                startTime: convertTimestampToDate(employee.shiftInfo.startTime),
                endTime: convertTimestampToDate(employee.shiftInfo.endTime)
            } : null
        }))
    };
};
